import { useEffect } from 'react';

function isCustomCurrencyEvent(message) {
  return (
    message.data &&
    message.data.event === 'customGBEvent' &&
    message.data.namespace === 'customConversionGBEvent'
  );
}

export function useEventBasedCurrencyConverter(cb) {
  useEffect(() => {
    const currencyConverterHandler = (message) => {
      if (isCustomCurrencyEvent(message)) {
        const { currency } = message.data.data;
        cb(currency);
      }
    };
    window.addEventListener('message', currencyConverterHandler);
    return () => {
      window.removeEventListener('message', currencyConverterHandler);
    };
  }, [cb]);
}

export default useEventBasedCurrencyConverter;
